"use client";

import { useEffect, useState } from "react";
import { ArrowRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function WhatIsForestryMulching() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3414" id="what-is-forestry-mulching" className="bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center">
      {}
      <div className="absolute inset-0 w-full h-[120%] -top-[10%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/mulching_forest_clearing.png)]" style={{
      transform: `translateY(${scrollY * 0.3}px)`
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(135deg, hsla(151, 67%, 6%, 0.85) 0%, hsla(151, 40%, 15%, 0.65) 50%, hsla(151, 67%, 6%, 0.95) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(ellipse at center, transparent 30%, hsla(151, 67%, 6%, 0.8) 100%)"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} aria-hidden="true" />

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-24 md:py-32">
        <div className="max-w-4xl">
          {}
          <div className="font-default text-xs md:text-sm uppercase mb-8 md:mb-12" style={{
          color: "hsl(23 90% 75%)",
          letterSpacing: "0.2em"
        }}>
            — SUSTAINABLE LAND MANAGEMENT
          </div>

          {}
          <h1 className="font-default font-bold leading-[0.95] mb-8 md:mb-10" style={{
          fontSize: "clamp(3.5rem, 11vw, 9rem)",
          letterSpacing: "-0.03em",
          color: "hsl(84 20% 98%)"
        }}>
            <span className="block">What Is</span>
            <span className="block">Forestry</span>
            <span className="block" style={{
            color: "hsl(23 90% 55%)"
          }}>
              Mulching?
            </span>
          </h1>

          {}
          <p className="font-default text-lg md:text-xl max-w-xl mb-10 md:mb-12 leading-relaxed" style={{
          color: "hsla(84, 20%, 98%, 0.8)"
        }}>
            Efficient land clearing that turns brush and trees into nutrient-rich mulch in a single pass.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 sm:items-center">
            <Link to="/ForestryMulchingPage">
              
            </Link>

            <Link to="#">
              <Button variant="outline" size="lg" className="rounded-lg h-12 px-7 font-default text-base bg-transparent border hover:bg-transparent" style={{
              borderColor: "hsla(84, 20%, 98%, 0.4)",
              color: "hsl(84 20% 98%)"
            }}>
                <Play className="size-4" />
              Contact Us
                <ArrowRight className="ml-1 size-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 md:bottom-12 right-6 md:right-10 lg:right-16 z-10 flex flex-col items-center gap-6">
        <div className="font-default text-[10px] md:text-xs uppercase hidden md:flex flex-col items-center gap-2" style={{
        color: "hsla(84, 20%, 98%, 0.7)",
        letterSpacing: "0.2em",
        writingMode: "vertical-rl"
      }}>
          <span>EFFICIENT / SUSTAINABLE / CLEAN</span>
        </div>

        {}
        <div className="relative h-12 w-px overflow-hidden">
          <div className="absolute top-0 left-0 w-px h-4 animate-scroll-line" style={{
          backgroundColor: "hsl(23 90% 55%)"
        }} />
          <div className="absolute inset-0 w-px" style={{
          backgroundColor: "hsla(84, 20%, 98%, 0.2)"
        }} />
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% {
            transform: translateY(-100%);
          }
          50% {
            transform: translateY(200%);
          }
          100% {
            transform: translateY(-100%);
          }
        }
        .animate-scroll-line {
          animation: scroll-line 2.5s ease-in-out infinite;
        }
      `}</style>
    </section>;
}